export default __webpack_public_path__ + "static/media/UsingTimer.31f46398.mp4";